if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
        this.isDoneFirstLoad = false;
        this.handleObserver = this.handleObserver.bind(this);
        this.onThumbnailClick = this.onThumbnailClick.bind(this);
        document.addEventListener('DOMContentLoaded', () => {
          this.track = this.querySelector('[js-product-slider-track]');
          if (this.track) {
            const slides = this.track.querySelectorAll('[js-product-slider-slide]');
            slides.forEach((slide, index) => {
              const observer = new IntersectionObserver(this.handleObserver, {
                root: this.track,
                rootMargin: '0px',
                threshold: 0.5,
              });
              observer.observe(slide);
            });

            const thumbnails = this.querySelectorAll('[js-slide-thumbnail]');
            for (const thumbnail of thumbnails) {
              $(thumbnail).click(this.onThumbnailClick);
            }

            const buttonPrev = this.querySelector('[js-product-slider-prev]');
            const buttonNext = this.querySelector('[js-product-slider-next]');

            $(buttonPrev).click(() => {
              this.track.scrollLeft -= this.track.offsetWidth;
            });
            $(buttonNext).click(() => {
              this.track.scrollLeft += this.track.offsetWidth;
            });
          }
        });
      }

      onThumbnailClick(event) {
        this.isDoneFirstLoad = true;
        const mediaId = event.currentTarget.getAttribute('data-media-id');
        const slide = this.querySelector(`[js-product-slider-slide][data-media-id="${mediaId}"]`);
        console.log(slide, "slide slide");
        
        if (slide) {
          this.track.querySelectorAll('[js-product-slider-slide]').forEach((slide) => {
            slide.classList.remove('active');
          });
          this.querySelectorAll('[js-slide-thumbnail]').forEach((thumbnail) => {
            thumbnail.classList.remove('active');
          });
          slide.classList.add('active');
          event.currentTarget.classList.add('active');
          this.track.scrollLeft = slide.offsetLeft - this.track.offsetWidth / 2 + slide.offsetWidth / 2;
        }
      }

      handleObserver(entries) {
        entries.forEach((entry) => {
          this.countTotalSlide += 1;
          if (!entry.isIntersecting) return;
          this.track.querySelectorAll('[js-product-slider-slide]').forEach((slide) => {
            slide.classList.remove('active');
          });
          this.querySelectorAll('[js-slide-thumbnail]').forEach((thumbnail) => {
            thumbnail.classList.remove('active');
          });
          
          entry.target.classList.add('active');
          const mediaId = entry.target.getAttribute('data-media-id');

          const thumbnail = this.querySelector(`[js-slide-thumbnail][data-media-id="${mediaId}"]`);
          const thumbnailContainer = document.querySelector('[js-slide-thumbnails]');
          if (thumbnail) {
            thumbnail.classList.add('active');
            thumbnailContainer.scrollLeft =
              thumbnail.offsetLeft - thumbnailContainer.offsetWidth / 2 + thumbnail.offsetWidth / 2;
            thumbnailContainer.scrollTop =
              thumbnail.offsetTop - thumbnailContainer.offsetHeight / 2 + thumbnail.offsetHeight / 2;
          }

          const thumbnailIndex = Array.from(this.querySelectorAll('[js-slide-thumbnail]')).indexOf(thumbnail);
          if (thumbnailIndex >= 0) {
            const buttonPrev = this.querySelector('[js-product-slider-prev]');
            const buttonNext = this.querySelector('[js-product-slider-next]');
            if (thumbnailIndex === 0) {
              buttonPrev.classList.add('opacity-50');
              buttonPrev.disabled = true;
            } else {
              buttonPrev.classList.remove('opacity-50');
              buttonPrev.disabled = false;
            }
            if (thumbnailIndex === this.querySelectorAll('[js-slide-thumbnail]').length - 1) {
              buttonNext.classList.add('opacity-50');
              buttonNext.disabled = true;
            } else {
              buttonNext.classList.remove('opacity-50');
              buttonNext.disabled = false;
            }
          }
          if (this.isDoneFirstLoad) return
        });
      }
    }
  );
}
